import React from "react";

import { Checkbox } from "../../checkbox";
import { Props } from "./types";
import styles from "./styles.scss";

function Portfolio({ portfolio, isSelected, select, unSelect }: Props) {
  return (
    <div className={styles.project} onClick={!isSelected ? select : unSelect}>
      <Checkbox isChecked={isSelected} />
      <p className={styles.name}>{portfolio.name}</p>
    </div>
  );
}

export { Portfolio };
